import { DEBUG } from '@src/DEBUG';
DEBUG.open ( '/service/feature-detector.ts' );

import {Injectable} from '@angular/core';
import {Constants, Typical} from '../commons/Constants';
import { Transform } from '4d-mapper';

import {MapService} from '../commons/map.service';
import { CoordHelperService } from './coord-helper.service';
import { XsIdentityInterface } from '../xs/interfaces/identify.interface';
import { EntityHelperService } from './entity-helper.service';
import { XsEventListenerInterface } from '../xs/interfaces/event-listener.interface';
import { XsApplicationEventsService } from '../xs/services/events/application-events.service';
import { XsPropsible } from '../xs/utilities/propsible.class';
import { XsEventify } from '../xs/services/events/eventify.class';
import { XsAwait } from '../xs/controllers/await.class';

const Cesium = (<any>window).Cesium;

@Injectable({
  providedIn: 'root'
})
export class FeatureDetectorService implements XsIdentityInterface {

  __ID = null;
  __EVENTS = null;

  debug:boolean = Constants.debug_off;
  debugPrimary:string = Constants._orange;
  debugSecondary:string = Constants._white;

  static itemStructures:any = {

    features: {

      // basic features
      isAlpha: false,
      canAlpha:true, // note: we assume all things can be opaque, and check if the really can as only some things can't

      // advanced features
      isColorized: false,
      canColorize: false,
      canHeightAdjust:false,
      isHeightAdjusted: false,
      hasReadyPromise: false,
      hasReadyPromiseInChild: false,
      isReady: false,
      hasLoading: false,
      hasLoadingEvent: false,

      // property values
      hasProperties: false,
      hasHeight: false,
      minHeight: null,
      maxHeight: null,

      // types
      isTileset: false,
      isTerrain:false,
      isPointCloud: false,
      isImage: false,
      isImageLayer: false,
      isDrawing: false,

      // interaction
      canBeClicked: false,
      canBeHovered: false,
      isHovered: false,
      canBeSelected: false,
      isSelected: false,

      // entity meta
      entityId: null,
      entityType: null,
      entityTransformRef: null,
      entityPluginRef: null,
      entity: null
      
    }, 

    gs: {
      boundingSphere: null,
      boundingPositions: null,
      boundingProfile: null,

      propertyNamesObj: [],
      propertyNamesAttr: [],
      propertyNamesEnt: [],
    },

    data: {
      rawPositions: null
    },
    
    issue: {
      tooltipToken: null,
      icon: 'exclamation-circle',
      isShown: false,
      value: null,
      note: null,
    }

  };

  checkTransformsFor:any = {
    features: {
      type: 'features',
      transformTypes: [ '*' ],
      datasetTypes: [],
    },
    gs: {
      type: 'gs',
      transformTypes: [ '*' ],
      datasetTypes: [],
    },
    /* test1: {
      type:'data',
      waitFor: 'gs',
      transformTypes: [ '*' ],
      datasetTypes: [],
    }, */
    /* heightOffset: {
      type: 'issue',
      waitFor: 'gs',
      transformTypes: [ 'three-d-tiles' ],
      datasetTypes: [],
    }, */
    /* test2: {
      type:'data',
      waitFor: 'heightOffset',
      transformTypes: [ '*' ],
      datasetTypes: [],
    }, */
    
  };

  viewer:any = null;

  // we can inject boundries into the perimeterPlugin
  perimeterPlugin:any = null;

  // quick list of all our checkers
  checkList:any = Object.keys ( this.checkTransformsFor );

  // lookup Tranforms _lut[T.id]
  _lut:any = {};

  // lookup Promises _promises[T.id][check]
  _promises:any = {};

  tilesets:any = {};

  testSlots:any = {};

  fastFlyDuration:number = 0.1;
  slowFlyDuration:number = 0.4;


  constructor ( 
    public mapService: MapService,  
    public coordHelper: CoordHelperService,
    public entityHelper: EntityHelperService,
    public applicationEvents: XsApplicationEventsService
  ) {
    DEBUG.log ( '/service/feature-detector.service.ts' );
    this.__ID = XsIdentityInterface.__init(this);
    this.__EVENTS = XsEventListenerInterface.__init(this);

  }

  ___mapViewerEnd( obj:any = null ) {
    if ( this.debug ) { console.log ( '%c feature-detector %c __mapViewerEnd', this.debugPrimary, this.debugSecondary, obj ); }
    this.viewer = obj.viewer;

    // master events for all things progressing in the Cesium engine
    // console.log('##############################', this.viewer.dataSources );

    /*
    let me = this;

    this.viewer.dataSources.dataSourceAdded.addEventListener( function(aa, bb, cc) {
      console.log('%c dataSource ADDED', Constants._red, aa, bb, cc );
      me.checkAndHook(bb);

    });

    this.viewer.dataSources.dataSourceMoved.addEventListener( function(aa, bb, cc) {
      console.log('%c dataSource MOVED', Constants._red, aa, bb, cc );
    });

    this.viewer.dataSources.dataSourceRemoved.addEventListener( function(aa, bb, cc) {
      console.log('%c dataSource REMOVED', Constants._red, aa, bb, cc );
    });
    */
  
  }

  /* checkAndHook ( e:any ) {

    const c = e.constructor.name;

    ['id','_id','name','_name'].forEach( key => {

    })
    const id = c;

    console.log('%c ## checking ['+id+'] ', Constants._green, e );

    if ( e['entities'] ) {
      console.log('%c ## ['+id+'] has [entities] collection', Constants._green, c );
      e['entities'].collectionChanged.addEventListener( function(aa, bb, cc) {
        console.log('%c ['+id+'] = [entities] collection event', Constants._orange, aa, bb, cc );
      });
    }

    // events and hooks

    // 'tileFailed','tileLoad','tileUnload','tileVisible',
    ['loadingEvent','changedEvent','errorEvent','allTilesLoaded','initialTileLoaded','loadingProgress','errorEvent'].forEach ( key => {
      if ( e[key] ) {
        console.log('%c ## ['+id+'] has ['+key+'] event', Constants._green, c );
        e[key].addEventListener( function(aa, bb, cc) {
          console.log('%c ['+id+'] = ['+key+'] event', Constants._orange, aa, bb, cc );
        });
      }
    });

    // promises (function / object)

    ['getViewableRectangle','readyPromise'].forEach ( key => {
      if ( e[key] ) {
        console.log('%c ## ['+id+'] has ['+key+'] promise', Constants._blue, c, typeof e[key] );
        if ( typeof e[key] == 'function' ) {
          // for functions that return a promise
          e[key]().then( function(aa, bb, cc) {
            console.log('%c ['+id+'] = ['+key+'] promise f', Constants._pink, aa, bb, cc );
          });
        } else {
          // for objects that are Promises
          e[key].then( function(aa, bb, cc) {
            console.log('%c ['+id+'] = ['+key+'] promise o', Constants._pink, aa, bb, cc );
          });
        }
      }
    });

  } */


  injectPlugin ( plugin:any = null ) {
    this.perimeterPlugin = plugin;
  }


  reset() {
    if ( this.debug ) { console.log ( '%c feature-detector %c reset()', this.debugPrimary, this.debugSecondary ); }
    this.testSlots = {};
  }

  checkTransform ( t:Transform, incomingObj:any = null ) {

    // hack to quick self improvement ...
    let me = this;

    // every Transform should have a progress section
    t['__progress'] = {
      item: { loading: { max:0, current:0 }, processing: { max:0, current:0 } },
      entity: { loading: { max:0, current:0 }, processing: { max:0, current:0 } },
      tiles: { log:{}, found:0, loaded:0 }
    };


    //if ( !this.perimeterPlugin ) {
    //  this.perimeterPlugin = this.pluginManager.findPlugin('perimeter','scene');
    //}

    // do we have more attached objects?
    let obj = this.mapService.helper.getMapObjectFor(t);
    if ( incomingObj ) {
      obj = incomingObj;
    }

    /*
    if ( obj.object ) {
      console.log('@@@@@ INITIAL DUMP', obj.object, this.dumpProps(obj.object,'TILESET'), 

      this.dumpProps(obj.object._resource,'RESOURCE'), 
      this.dumpProps(obj.object._asset,'ASSET'), 
      this.dumpProps(obj.object._properties,'PROPERTIES'), 
      this.dumpProps(obj.object._backfaceCommands,'BACKFACE'), 
      this.dumpProps(obj.object._heatmap,'HEATMAP'), 
      this.dumpProps(obj.object._root,'ROOT_TILE') );
    }
    */

    // some basic id's and types
    let meta = {
      id:    t['id'],
      ttype: t['type_uid'],
      dtype: t['ds_type_uid'],
      etype: obj.object ? obj.object.constructor.name : 'unknown',
      features: {}
    }

    if ( !this._lut[meta.id] ) {
      this._lut[meta.id] = t;
    }
    
    // is there an issues log? No? create it
    if ( ! t.hasOwnProperty('__detected') ) {
      t['__detected'] = {};
    }
    if ( ! t['__detected'].hasOwnProperty('_meta') ) {
      t['__detected']['_meta'] = meta;
    }

    if ( this.debug ) { 
      console.log (' ----------------------------------------------------------- ');
      console.log ( '%c feature-detector %c checkTransform('+meta.id+') INCOMING = ', this.debugPrimary, this.debugSecondary, t, t['__detected'] ); 
    }

    return new Promise ( (resolve,reject) => {

      let checkedCount = 0;

      // console.log ( '@@@@@@@@ I promise to check this Transform', t.id );

      // go through all checks
      this.checkList.forEach ( key => { 

        // this is the test we're currently running
        let test = this.checkTransformsFor[key];

        // create any missing lists
        if ( ! t['__detected'][test.type] ) {
          t['__detected'][test.type] = {};
        }

        // the result of the test ends up in this list
        let list = t['__detected'][test.type];

        // an item is rooted when it's got the same name as the tester, so the result should go 
        // directly to the list and not pushed as a child item
        let isRooted:boolean = false;
        if ( test.type == key ) {
          isRooted = true;
          // if ( this.debug ) { console.log ( '%c feature-detector %c checkTransform('+meta.id+') ROOTED = '+key, this.debugPrimary, this.debugSecondary ); }
        }

        // the test function to run
        const tester = '__' + key;
        // const runner = '__run__' + key;

        // console.log ( '@@@@@@@@ check for criteria', key, meta, test );

        // we start by checking if the test criteria matches the Transform in question
        if ( this.testCriteria ( key, meta, test ) ) {

          // the item is what we're testing. null is a new entry (as in, not tested before)
          let item = null;

          // All tests are promises
          if ( !this._promises[t.id] ) {
            this._promises[t.id] = {};
          }

          if ( isRooted ) {

            // create a new structure (based on its type)
            item = this.getNewStructure ( test, meta, key );

            // if ( this.debug ) { console.log ( '%c feature-detector %c checkTransform('+meta.id+') TESTING **NEW-ROOTED** = '+key, this.debugPrimary, this.debugSecondary, item ); }

          } else {

            // does the list have an entry for this test?
            if ( list.hasOwnProperty(key) ) {

              // insert old results before re-testing
              item = list[key];

              // if ( this.debug ) { console.log ( '%c feature-detector %c checkTransform('+meta.id+') TESTING OLD = '+key, this.debugPrimary, this.debugSecondary, t, item ); }

            } else {

              // create a new structure (based on its type)
              item = this.getNewStructure ( test, meta, key );

              // if ( this.debug ) { console.log ( '%c feature-detector %c checkTransform('+meta.id+') TESTING **NEW** = '+key, this.debugPrimary, this.debugSecondary, item ); }
            }
          }
          
          // if null (NEW item) or old item that hasn't been dismissed
          if ( !item.isDismissed  ) {

            // if ( this.debug ) { console.log ( '%c feature-detector %c checkTransform('+meta.id+') NOT DISMISSED = '+key, this.debugPrimary, this.debugSecondary, tester ); }

            // console.log ( '@@@@@@@@ not dismissed, so check', key, tester );

            // quick check for the testing function
            if ( me[tester] ) {

              // console.log ( '@@@@@@@@ PROMISE', key );

              if ( test.waitFor && this._promises[t.id][test.waitFor] ) {

                // console.log ( '@@@@@@@@ PROMISE WAIT for', key, test.waitFor );

                this._promises[t.id][test.waitFor].then( result => {

                  // console.log ( '@@@@@@@@ PROMISE done WAITING, running', key, test.waitFor );

                  this._promises[t.id][key] = me[tester]( t, item, obj ).then( result => {

                    meta[key] = result;
                    t['__detected'][test.type] = result;
                
                    checkedCount++;
                    if ( checkedCount == this.checkList.length ) {
                      // console.log ( '@@@@@@@@ waited THEN, kept my promise', key, this.checkList.length, checkedCount, t['__detected']._meta );
                      resolve(meta);
                    } else {
                      // console.log ( '@@@@@@@@ waited THEN, checked', key, this.checkList.length, checkedCount, t['__detected']._meta );
                    }
                  });

                });
        
              } else {
        
                // console.log ( '@@@@@@@@ PROMISE no waiting, running', key, test.waitFor );

                this._promises[t.id][key] = me[tester]( t, item, obj ).then( result => {
                
                  meta[key] = result;
                  t['__detected'][test.type] = result;

                  checkedCount++;
                  if ( checkedCount == this.checkList.length ) {
                    // console.log ( '@@@@@@@@ THEN, kept my promise', key, this.checkList.length, checkedCount, t['__detected']._meta );
                    resolve(meta);
                  } else {
                    // console.log ( '@@@@@@@@ THEN, checked', key, this.checkList.length, checkedCount, t['__detected']._meta );
                  }
                });

              }
            }
    
          } else {
            // count even those we've checked before
            checkedCount++;
            if ( checkedCount == this.checkList.length ) {
              // console.log ( '@@@@@@@@ kept my promise (dismissed)', key, this.checkList.length, checkedCount, t['__detected']._meta );
              resolve(meta);
            } else {
              // console.log ( '@@@@@@@@ checked (dismissed)', key, this.checkList.length, checkedCount, t['__detected']._meta );
            }
          }
        } else {
          // count even those we skip
          checkedCount++;
          if ( checkedCount == this.checkList.length ) {
            // console.log ( '@@@@@@@@ kept my promise (skipped)', key, this.checkList.length, checkedCount, t['__detected']._meta );
            resolve(meta);
          } else {
            // console.log ( '@@@@@@@@ checked (skipped)', key, this.checkList.length, checkedCount, t['__detected']._meta );
          }
        }
        
      });

      if ( this.debug ) { 
        console.log ( '%c feature-detector %c checkTransform('+meta.id+') testing harness DONE', this.debugPrimary, this.debugSecondary, t, t['__detected'], this._promises[t.id] );
        console.log('');console.log(''); 
      }

    });

  }

  getNewStructure ( test:any, meta:any = {}, name:string = 'unknown' ) {
    let ret = {
      _name: name,
      isDismissed: false
    };
    Object.keys(test).forEach ( k => {
      ret[k] = test[k];
    });
    if ( FeatureDetectorService.itemStructures[test.type] ) {
      const structure = FeatureDetectorService.itemStructures[test.type];
      Object.keys(structure).forEach ( k => {
        ret[k] = structure[k];
      });
    }
    return ret;
  }

  testCriteria ( key:string, meta:any, test:any = null, testingParent:boolean = false ) {

    let id = key + '_' + meta.id + '_' + meta.dtype + (testingParent ? '_PARENT':'');

    let runTest:boolean = false;

    if ( test.waitFor ) {
      if ( this.checkTransformsFor[test.waitFor] ) {
        // if ( this.debug ) { console.log ( '%c feature-detector %c testCriteria('+id+') waitingOn?', this.debugPrimary, this.debugSecondary, test.waitFor ); }
        let parentTest = this.testCriteria ( key, meta, this.checkTransformsFor[test.waitFor], true );
        if ( this.debug ) { console.log ( '%c feature-detector %c testCriteria('+id+') waitingOn?', this.debugPrimary, this.debugSecondary, parentTest ); }
        // if the parent's test was false (ie. the test shouldn't or wasn't run), then we shouldn't run either
        if ( !parentTest ) {
          return false;
        }
      }
    }

    if ( test.transformTypes && test.transformTypes.length ) {
      let find = test.transformTypes.find( f => f == meta.ttype );
      // check for '*', meaning anything goes
      if ( !find && test.transformTypes.length == 1 && test.transformTypes[0] == '*' ) {
        find = true;
      }
      if ( find ) {
        runTest = true;
      }
    }
    if ( test.datasetTypes && test.datasetTypes.length ) {
      let find = test.datasetTypes.find( f => f == meta.dtype );
      // check for '*', meaning anything goes
      if ( !find && test.datasetTypes.length == 1 && test.datasetTypes[0] == '*' ) {
        find = true;
      }
      if ( find ) {
        runTest = true;
      }
    }
    if ( this.debug ) { console.log ( '%c feature-detector %c testCriteria('+id+') runTest?', this.debugPrimary, this.debugSecondary, runTest, testingParent ? 'FOR_PARENT':'' ); }
    return runTest;
  }

  removeAll() {
    this.perimeterPlugin = null;
    this._lut = {};
    this._promises = {};
  }

  lookupResults ( tid:number, name:string = 'features', inList:string = 'root' ) {
    // if ( this.debug ) { console.log ( '%c feature-detector %c lookupResults('+tid+','+name+','+inList+')', this.debugPrimary, this.debugSecondary, this._lut ); }
    if ( this._lut[tid] ) {
      let t = this._lut[tid];
      if ( inList == 'root' ) {
        if ( t['__detected'][name] ) {
          return t['__detected'][name];
        }
      } else {
        if ( t['__detected'][name][inList] ) {
          return t['__detected'][name][inList];
        }
      }
    }
    return null;
  }

  // bulk standard features (mostly based off types)
  __features ( t:Transform, test:any = null, obj:any = null ) {

    let meta = t['__detected']['_meta'];

    if ( !t.hasOwnProperty('__check_feature') ) {
      t['__check_feature'] = function ( check:any ){
        if ( t['__detected'] && t['__detected']['features'] && t['__detected']['features'][check] ) {
          return true;
        }
        return false;
      };
    }

    return new Promise ( (resolve,reject) => {

      // if ( this.debug ) { console.log ( '%c feature-detector %c __features() START', this.debugPrimary, this.debugSecondary, meta ); }

      if ( meta.dtype == 'e57' || meta.dtype == 'pointcloud-tile' || meta.dtype == 'laz' || meta.dtype == 'laslaz' || meta.ttype == 'ply' || meta.ttype == 'e57' ) {
        // this.sceneController.report ( t.id, A.POINTCLOUD, STATE.YES );
        test.isPointCloud = true;
        test.canColorize = true;
      }

      if ( meta.dtype == 'laslaz' || meta.dtype == 'e57' || meta.ttype == 'terrain-tiles' ) {
        test.canAlpha = false;
        test.canColorize = true;
      }

      if ( meta.ttype == 'terrain-tiles' ) {
        // this.sceneController.report ( t.id, A.TERRAIN, STATE.YES );
        test.isTerrain = true;
        test.canAlpha = false;
      }

      if ( meta.ttype == 'geo-json' || meta.ttype == 'kml' ) {
        test.canAlpha = false;
      }

      if ( meta.ttype == 'three-d-tiles' ) {
        test.canHeightAdjust = true;
      }

      // console.log ( '%c feature-detector %c __features() RESOLVE', this.debugPrimary, this.debugSecondary, meta, obj );

      if ( obj ) {

        let e = obj['object'];
        // test.entity = e;

        if ( e ) {
    
          test.entityId = e.id;
          test.entityType = e.constructor.name;

          if ( e['readyPromise'] ) {
            test.hasReadyPromise = true;
          }
          if ( e.hasOwnProperty('ready') ) {
            test.isReady = e.ready;
          }

          test.hasLoadingEvent = e['loadingEvent'] ? true : false;

          if ( e.hasOwnProperty('_isLoading') ) {
            test.hasLoading = true;
          }
          if ( e['transform_id'] ) {
            test.entityTransformRef = e['transform_id'];
          }
    
          if ( test.entityType == 'ImageryLayer' || (t.transformType && t.transformType.name == 'TMS')) {

            test.isClickable = false;
            test.isImageLayer = true;
            
            let p = e._imageryProvider;
            if ( p['readyPromise'] ) {
              test.hasReadyPromise = true;
              test.hasReadyPromiseInChild = '_imageryProvider';
            }
            if ( p.hasOwnProperty('ready') ) {
              test.isReady = p.ready;
            }
            
          } else if ( test.entityType == 'Cesium3DTileset') {

            test.isClickable = true;
            test.isTileset = true;
    
            if ( e._properties ) {
              test.hasProperties = true;
              if ( e._properties.Height ) {
                test.hasHeight = true;
                if ( e._properties.Height.maximum ) {
                  test.maxHeight = e._properties.Height.maximum;
                }
                if ( e._properties.Height.minimum ) {
                  test.minHeight = e._properties.Height.minimum;
                }
              }
            }
            // not reliable
            // if ( e.pointCloudShading ) {
            //   test.isPointcloud = true;
            // }


          }
        }

        // finally, can this item be transparent?
        // this.sceneController.report ( t.id, A.TRANSPARENT_ITEM, test.canAlpha );

      }

      if ( this.debug ) { console.log ( '%c feature-detector %c __features() RESOLVE', this.debugPrimary, this.debugSecondary, meta, test ); }
      resolve(test);

    });

  }

  dumpProps(obj,name:string = null){
    let ret = [];
    if ( name ) {
      ret.push('-- '+name+' --');
    }
    if ( obj ) {
      Object.keys(obj).forEach ( key => {
        const type = typeof obj[key];
        if ( type == 'string' || type == 'boolean' || type == 'bigint' || type == 'number' ) {
          ret.push(key + ' [' + type + '] = ' + obj[key] );
        } else {
          if ( type == 'object' ) {
            const c = Object.keys(obj[key]);
            ret.push(key + ' [' + type + '] ('+c.length+')' );
          } else {
            ret.push(key + ' [' + type + ']' );
          }
        }
      });
    }
    return ret;
  }

  keyify ( v:any ) {
    v = (''+v).trim();
    return '_' + JSON.stringify(v).replace(/[\"\']/g, '_')
  }


  // geospatial stuff
  __gs ( t:Transform, test:any = null, obj:any = null ) {
    
    let meta = t['__detected']['_meta'];
    let me = this;

    const isPointCloud = meta.features.isPointCloud;
    const shouldHookEvents:boolean = t['__propertiesStreaming'] ? true : false;

    // console.log('%c ## features __gs', Constants._green, shouldHookEvents, t, test, obj );

    return new Promise ( (resolve,reject) => {

      // resolve(null); return;

      // if ( true || this.debug ) { console.log ( '%c feature-detector %c __gs() START', this.debugPrimary, this.debugSecondary, meta, t, obj ); }

      let finalResolve = resolve;

      if ( obj ) {

        // has a bounding sphere (and centre)
        if ( obj.boundingSphere ) {
          test.boundingSphere = { 
            center:{ x:obj.boundingSphere.center.x, y:obj.boundingSphere.center.y, z:obj.boundingSphere.center.z }, 
            radius:obj.boundingSphere.radius
          };
        }

        if ( obj.object ) {

          const e = obj.object;
          const c = e.constructor.name

          // console.log('%c ## features OBJ', Constants._green, shouldHookEvents, c, e );

          if ( shouldHookEvents ) {
            me.applicationEvents.triggerInit('tilesLoading');
          }


          /*
          if ( e['entities'] ) {
            console.log('%c ## has [entities] collection', Constants._green, c );
            e['entities'].collectionChanged.addEventListener( function(aa, bb, cc) {
              console.log('%c [entities] collection event', Constants._orange, aa, bb, cc );
            });
          }

          // events and hooks

          // 'tileFailed','tileLoad','tileUnload','tileVisible',
          ['loadingEvent','changedEvent','errorEvent','allTilesLoaded','initialTileLoaded','loadingProgress','errorEvent'].forEach ( key => {
            if ( e[key] ) {
              console.log('%c ## has ['+key+'] event', Constants._green, c );
              e[key].addEventListener( function(aa, bb, cc) {
                console.log('%c ['+key+'] event', Constants._orange, aa, bb, cc );
              });
            }
          });

          // promises (function / object)

          ['getViewableRectangle','readyPromise'].forEach ( key => {
            if ( e[key] ) {
              console.log('%c ## has ['+key+'] promise', Constants._blue, c, typeof e[key] );
              if ( typeof e[key] == 'function' ) {
                // for functions that return a promise
                e[key]().then( function(aa, bb, cc) {
                  console.log('%c ['+key+'] promise f', Constants._pink, aa, bb, cc );
                });
              } else {
                // for objects that are Promises
                e[key].then( function(aa, bb, cc) {
                  console.log('%c ['+key+'] promise o', Constants._pink, aa, bb, cc );
                });
              }
            }
          });
          */
        
          // const type = e['properties'] ? typeof e['properties'] : null;
          // t['__properties'] = {};

          // console.log ( '%c feature-detector %c __gs() properties', this.debugPrimary, this.debugSecondary, e, e['properties'], type );

          

          if ( shouldHookEvents && e.allTilesLoaded ) {
            e.allTilesLoaded.addEventListener(function() {
              // console.log('%c All tiles are loaded ', Constants._yellow, t['__progress'].tiles.loaded );
              me.applicationEvents.triggerEnd('tilesLoading');
            });
          }

          // console.log('## meta', meta );

          

          if ( shouldHookEvents && !isPointCloud && e.tileLoad ) {

            /* for future reference ...
              buildingTileSet.tileLoad.addEventListener(tile => {
                let content = tile.content;
                let featuresLength = content.featuresLength;

                for (var i = 0; i < featuresLength; i += 2) {
                  let feature = content.getFeature(i);
                  let model = feature.content._model;

                  Object.keys(model._sourcePrograms).forEach(key => {
                    let program = model._sourcePrograms[key];
                    model._rendererResources.sourceShaders[
                      program.vertexShader
                    ] = VS;
                    model._rendererResources.sourceShaders[
                      program.fragmentShader
                    ] = FS;
                  });
                  model._shouldRegenerateShaders = true;
                }
              });
            */

            
            e.tileLoad.addEventListener(function(tile) {

              t['__progress'].tiles.loaded++;

              if ( !t['__properties'] ) {
                t['__properties'] = {};
              }
              let properties = t['__properties'];
              if ( !properties.___tile_uuid ) {
                properties.___tile_uuid = {};
              }

              let uuid = tile['__uuid'];

              if ( !properties.___tile_uuid[uuid] ) {
                properties.___tile_uuid[uuid] = 0;
              }
              properties.___tile_uuid[uuid]++;

              t['__progress'].tiles.log[uuid] = t['__progress'].tiles.log[uuid] + + ' | loaded ('+t['__progress'].tiles.loaded+')';
              // test.totalTiles[uuid] = test.totalTiles[uuid] + ' | loaded ('+test.tilesLoaded+')';

              
              // when a tile is loaded, the content is available, so we can pick and analyse the properties and their values
              const content = tile._content;
              const featuresLength = content.featuresLength;

              // we do this rigmorole because if we use _properties directly, not all batched properties are correct
              // so using the Cesium property API converts them for us

              let allProps = {};
              const fullAnalysis = true;
              if ( fullAnalysis ) {
                for ( let n=0; n<featuresLength; n++ ) {
                  let c = content.getFeature(n);
                  if ( c ) {
                    c.getPropertyNames().forEach(name => {
                      let p = c.getProperty(name);
                      if ( !allProps[name] ) {
                        allProps[name] = [];
                      }
                      allProps[name].push(p);
                    });
                    
                  }
                }
              } else {
                allProps = content._batchTable['_properties'];
              }

              // console.log('%c Tile loaded ', Constants._yellow, uuid, allProps );

              // analyze the props in the Transform['__properties'] structure
              XsPropsible.analyzeProperties( t, allProps, 'feature-detector:tile:propsAPI' );
              
              // send out the props to all who wants them
              me.applicationEvents.triggerStart('tilesLoading', allProps );
              
              // bit of a hack; after 5 tiles are loaded (a random number chosen from experience), we'll
              // trigger an End event, making a lot of UI's able to at least start populating property names ...

              if ( t['__progress'].tiles.loaded == 3 || t['__progress'].tiles.loaded == 20 || t['__progress'].tiles.loaded == 40 || t['__progress'].tiles.loaded == 200 ) {
                me.applicationEvents.triggerEnd('tilesLoading', allProps );
              }

              


            });
          }
          if ( shouldHookEvents && !isPointCloud && e.loadProgress ) {

            e.loadProgress.addEventListener(function(numberOfPendingRequests, numberOfTilesProcessing) {

              if ((numberOfPendingRequests === 0) && (numberOfTilesProcessing === 0)) {
                t['__progress']['entity'].max = 0;
                // console.log('%c All tiles loaded, progress ended ', Constants._yellow );
                // console.log('Finished loading, property analysis result=',t['__properties']);

                // all properties analysis are done, so save the Transform to preserve it for next time
                // t.saveObservable().subscribe();

                if ( t['__properties_updated'] ) {
                  t['__properties_updated']();
                }
                return;
              }
              if ( numberOfPendingRequests > t['__progress']['entity'].max ) {
                t['__progress']['entity'].max = numberOfPendingRequests;
                console.log('# loadProgress', shouldHookEvents, isPointCloud, t );
              }
              t['__progress']['entity'].current = numberOfPendingRequests;
              // console.log('%c Tiles loading ... requests=' + numberOfPendingRequests + ', processing=' + numberOfTilesProcessing, Constants._yellow );

              // console.log('tileLoadingUpdate() requests: ' + numberOfPendingRequests + ', processing: ' + numberOfTilesProcessing, t['__progress']['entity'] );
            });
          }

          
          if ( e['getPropertyNames'] ) {
            // console.log ( '%c feature-detector %c __gs() properties A', this.debugPrimary, this.debugSecondary, e.getPropertyNames() );
            XsPropsible.analyzeProperties(t,e.getPropertyNames(), 'feature-detector:getPropNames' );
          }

          if ( e['properties'] && e.properties['getValue'] ) {
            // console.log ( '%c feature-detector %c __gs() properties B', this.debugPrimary, this.debugSecondary, e.properties.getValue() ); 
            XsPropsible.analyzeProperties(t,e.properties.getValue(), 'feature-detector:props.getValue' );
          } 
          if ( e['_properties'] ) {
            // console.log ( '%c feature-detector %c __gs() properties D', this.debugPrimary, this.debugSecondary, e['_properties'] ); 
            XsPropsible.analyzeProperties(t,e['_properties'], 'feature-detector:_props' );
          }

          if ( e['getProperties'] ) {
            // console.log ( '%c feature-detector %c __gs() properties E', this.debugPrimary, this.debugSecondary, e.getProperies() );
            XsPropsible.analyzeProperties(t,e.getProperties(), 'feature-detector:getProps' );
          }
          
          test.propertyNamesEnt = this.entityHelper.getEntityProperties ( e.id );
          XsPropsible.analyzeProperties(t,test.propertyNamesEnt, 'feature-detector:entityProps' );

          // is an imagery provider (image layer on the globe)
          if ( obj.object.imageryProvider ) {

            if ( this.debug ) { console.log ( '%c feature-detector %c __gs() imageProvider START', this.debugPrimary, this.debugSecondary, meta, test ); }

            obj.object.getViewableRectangle().then(function (rectangle) {
      
              test.boundingPositions = Cesium.Rectangle.subsample(rectangle, Cesium.Ellipsoid.WGS84, 20.0 );

              if ( me.debug ) { console.log ( '%c feature-detector %c __gs() RESOLVE imageProvider DONE', me.debugPrimary, me.debugSecondary, meta, test ); }

              // sub sends back calculated corners of the image layer
              finalResolve (test);
    
            }, function (error) {
              if ( me.debug ) { console.log ( '%c feature-detector %c __gs() RESOLVE imageProvider END ERROR', me.debugPrimary, me.debugSecondary, meta, test ); }
              finalResolve(null);
            });

          } else {

            if ( shouldHookEvents && !isPointCloud && obj.object._root ) {

              const root = obj.object._root;

              if ( this.debug ) { console.log ( '%c feature-detector %c __gs() RESOLVE', this.debugPrimary, this.debugSecondary, meta, test, obj.object ); }

              // me.applicationEvents.triggerStart('tilesLoading');

              if ( e.readyPromise ) {
                e.readyPromise.then( z => {

                  let pos = this.traverseTiles ( t, root );
                  // test['_traverse'] = pos;
                  test.boundingPositions = [];
                  pos.forEach(p => {
                    test.boundingPositions.push(p.pos);
                  });

                  t['__progress']['entity'].max = pos.length;

                  // console.log ( '%c feature-detector %c __gs() PROMISED TRAVERSE_TILES ############################################################################', this.debugPrimary, this.debugSecondary, 
                  // pos.length ); // obj.object, test, pos, this.dumpProps(e._content) );

                  finalResolve ( test );

                });
              } else {
                let pos = this.traverseTiles ( t, root );
                // test['_traverse'] = pos;
                test.boundingPositions = [];
                pos.forEach(p => {
                  test.boundingPositions.push(p.pos);
                });
                t['__progress']['entity'].max = pos.length;
                // console.log ( '%c feature-detector %c __gs() TRAVERSE_TILES, NO PROMISE ############################################################################', this.debugPrimary, this.debugSecondary, 
                // pos.length ); //   obj.object, test, pos );
                finalResolve ( test );
              }

              
            } else {

              if ( this.debug ) { console.log ( '%c feature-detector %c __gs() RESOLVE no root', this.debugPrimary, this.debugSecondary, meta, test ); }
              finalResolve(null);
            }
          }
        } else {

          if ( this.debug ) { console.log ( '%c feature-detector %c __gs() RESOLVE, no entity', this.debugPrimary, this.debugSecondary, meta, test ); }
          finalResolve(null);
        }

      } else {

        if ( this.debug ) { console.log ( '%c feature-detector %c __gs() RESOLVE, no obj', this.debugPrimary, this.debugSecondary, meta, test ); }
        finalResolve(null);
      }
    });

  }

  __test1 ( t:Transform, test:any = null, obj:any = null ) {

    let meta = t['__detected']['_meta'];
    if ( this.debug ) { console.log ( '%c feature-detector %c __run__test1() STARTED', this.debugPrimary, this.debugSecondary, meta, test ); }

    return new Promise ( (resolve,reject) => {
      if ( this.debug ) { console.log ( '%c feature-detector %c __run__test1() RESOLVED', this.debugPrimary, this.debugSecondary, meta, test ); }
      resolve(null);
    });

  }

  
  __test2 ( t:Transform, test:any = null, obj:any = null ) {

    let meta = t['__detected']['_meta'];
    if ( this.debug ) { console.log ( '%c feature-detector %c __test2() STARTED', this.debugPrimary, this.debugSecondary, meta, test ); }

    return new Promise ( (resolve,reject) => {
      if ( this.debug ) { console.log ( '%c feature-detector %c __test2() RESOLVED', this.debugPrimary, this.debugSecondary, meta, test ); }
      resolve(null);
    });
  }

  flyThere ( cartographic:any, height:number = 200, duration:number = this.fastFlyDuration, debug:any = null ) {
    let id = null;
    if ( debug ) {
      id = debug;
    }

    if ( this.debug ) { console.log ( '%c feature-detector %c ['+id+'] flyThere()', this.debugPrimary, this.debugSecondary, cartographic, height, duration ); }
    let me = this;
    return new Promise( (resolve,reject) => {
      if ( this.viewer ) {
        if ( !height ) {
          height = cartographic.height;
        }
        this.viewer.camera.setView({
          duration: duration,
          destination : Cesium.Cartesian3.fromDegrees(cartographic.longitude, cartographic.latitude, height ),
          /* complete: function () {
            if ( me.debug ) { console.log ( '%c feature-detector %c ['+id+'] flyThere() ARRIVED', me.debugPrimary, me.debugSecondary, cartographic, height, duration ); }
            resolve(null);
          },
          cancel: function () {
            if ( me.debug ) { console.log ( '%c feature-detector %c ['+id+'] flyThere() ARRIVED ON CANCEL', me.debugPrimary, me.debugSecondary, cartographic, height, duration ); }
            resolve(null);
          } */
        });
        setTimeout ( ()=>{ resolve(null); }, 10);
      } else {
        if ( this.debug ) { console.log ( '%c feature-detector %c ['+id+'] flyThere() NO_VIEWER', this.debugPrimary, this.debugSecondary, cartographic, height, duration ); }
        resolve(null);
      }
    });
  }

  traverseTiles ( transform:any, tile:any = null, ret:any = [], depth:number = 0 ) {

    if ( !tile ) {
        return null;
    }

    let check = this.checkTile ( transform.id, tile, depth );

    transform['__progress'].tiles.found++;
    transform['__progress'].tiles.log[tile.__uuid] = 'found ('+transform['__progress'].tiles.found+')';

    // this.totalTiles[tile.__uuid] = 'found ('+this.totalTilesCount+')';
    // this.totalTilesCount++;

    // is this the root tile?
    if ( depth == 0 ) {
      // t['ROOT_TILE'] = { root:tile, c: tile['content'], _c:tile['_content'] };
      // console.log('@@@@@ROOT',this.dumpProps(tile), this.dumpProps(tile._contentResource), tile );
      /*
      if ( tile._content && tile._content._batchTable ) {
        t['batchProps'] = tile._content._batchTable._properties;
      }
      if ( tile._content && tile._content._features ) {
        t['features'] = {};
        tile._content._features.forEach ( f => {
          let id = f._batchId;
          let p = [];
          Object.keys(f).forEach ( key => {
            p.push(key);
          });
          t['features']['_'+id] = { id:id, propNames: f.getPropertyNames(), p: p } 
        });
        
      }
      */
    }

    ret.push(check);

    if ( tile.children ) {
      tile.children.forEach(t => {
          ret = this.traverseTiles ( transform, t, ret, depth + 1 );
      });
    }

    // console.log ( '****** traverseTiles()', ret );

    /* if ( depth == 0 ) {
      console.log('@@@@@ROOT', this.totalTiles );
    } */

    return ret;

  }

  uuidv4( token:string = '-', prefix:string = '') {
    return ( prefix + 'xxxxxxxx'+token+'xxxx'+token+'4xxx'+token+'yxxx'+token+'xxxxxxxxxxxx').replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
  }




  basicCartesian ( c:any ) {
    const o:object = { x: c.x, y: c.y, z: c.z, id:this.uuidv4() };
    return o;
  }

  checkTile ( tid:number, tile:any, depth:number = 0 ) {
    let c = [];
    let t = {
        tid:tid,
        uuid: tile['__uuid'] ? tile['__uuid'] : this.uuidv4('_','_'),
        updated:false,
        pickId:null,
        children:0,
        centerZDepth: null,
        distance: null,
        points: null,
        contentState: null,
        rad: null,
        pos: null,
        batchedProps: null,
        _content:false, 
        _batchTable: false,
        _properties: false
        // changeLog: []
    }

    
    
    const uuid = t.uuid; // tile['uuid'] ? tile['uuid'] : this.uuidv4();


    /*
    if ( tile._content ) {
      t._content = true;
      if ( tile._content._batchTable ) {
        t._batchTable = true;
        if ( tile._content._batchTable._properties ) {
          t._properties = true;
          t.batchedProps = tile._content._batchTable._properties;
        }
      }
    }
    */

    if ( ! tile.__uuid ) {
      tile.__uuid = uuid;
    }
    if ( ! tile.__uuid_depth ) {
      tile.__uuid_depth = depth;
    }
    if ( !tile.__tid ) {
        tile.__tid = tid;
        // c.push('tile.tid');
    }

    if ( tile.children ) {
        t.children = tile.children.length;
    }
    if ( tile._boundingVolume && tile._boundingVolume._boundingSphere ) {
        t.pos = this.basicCartesian ( tile._boundingVolume._boundingSphere.center );
        t.rad = tile._boundingVolume._boundingSphere.radius;
        // c.push('bounding');
    }
    if ( tile._centerZDepth ) {
        t.centerZDepth = tile._centerZDepth;
        // c.push('center');
    }
    if ( tile._distanceToCamera ) {
        t.distance = tile._distanceToCamera;
        // c.push('distance');
    }
    // if ( tile._content && tile._content._pickId ) {
        // t.pickId = tile._content._pickId.key;
        // c.push('pick');
        /* if ( tile._content._pickId._pickObjects && tile._content._pickId._pickObjects[t.pickId] ) {
            if ( tile._content._pickId._pickObjects[t.pickId].content ) { }
        } */
    // }
    // if ( tile._content && tile._content.pointsLength ) {
    //     t.points = tile._content.pointsLength;
        // c.push('points');
    // }

    t.contentState = tile._contentState;

    // this.checkContentReady('tile',tile);

    // t.changeLog.push(c);
    // this.tilesets['t_'+tid][uuid] = t;


    /*
    const content = tile._content;
    if ( content ) {
      const featuresLength = content['featuresLength'];

      console.log('!!searchingForPropsInTile',content, featuresLength );

      // we do this rigmorole because if we use _properties directly, not all batched properties are correct
      // so using the Cesium property API converts them for us
  
      let allProps = {};
      const fullAnalysis = true;
      if ( fullAnalysis && featuresLength ) {
        for ( let n=0; n<featuresLength; n++ ) {
          let c = content.getFeature(n);
          if ( c ) {
            c.getPropertyNames().forEach(name => {
              let p = c.getProperty(name);
              if ( !allProps[name] ) {
                allProps[name] = [];
              }
              allProps[name].push(p);
            });
            
          }
        }
        console.log('!!foundPropsInTile',allProps);
      } else {
        allProps = content._batchTable['_properties'];
      }
    } else {
      console.log('!!noPropsInTile', [ tile, [ this.dumpProps(tile._header), this.dumpProps(tile._header.content), this.dumpProps(tile._contentResource), this.dumpProps(tile) ] ] );
    }
    */

    // console.log ( '%c feature-detector %c checkTile', this.debugPrimary, this.debugSecondary, tid, t, tile, this.dumpProps(tile) );
    return t;
  }

  __heightOffset ( t:Transform, test:any = null, obj:any = null ) {

    let meta = t['__detected']['_meta'];

    let me = this;

    return new Promise ( (resolve,reject) => {

      
      let ret = null;
      let gs = me.lookupResults ( t.id, 'gs' );

      // if ( this.debug ) { console.log ( '%c feature-detector %c __heightOffset()', this.debugPrimary, this.debugSecondary, t, test, gs, obj ); }

      if ( gs && gs.boundingSphere ) {

        const ex = [ obj.object ];
        const origin = me.coordHelper.positionProfile ( me.mapService.viewer.scene, 'original', gs.boundingSphere.center, { ex:ex } );

        me.testSlots[t.id] = true;
        let pos = Object.keys(me.testSlots);
        let pp = 300 + ( pos.length * ( me.fastFlyDuration * 100 ) );
        let tt = 3000 + ( pos.length * ( me.slowFlyDuration * 100 ) );

        if ( me.debug ) { console.log ( '%c feature-detector %c ['+t.id+'] __heightOffset() START', Constants._red, Constants._red, test, meta, pp, tt ); }


        setTimeout ( ()=>{

          if ( me.debug ) { console.log ( '%c feature-detector %c ['+t.id+'] __heightOffset() GOING FLYING ...', me.debugPrimary, me.debugSecondary, pp ); }

          me.flyThere(origin.cartographic,20000,me.fastFlyDuration,t.id).then( _ => {

            if ( me.debug ) { console.log ( '%c feature-detector %c ['+t.id+'] __heightOffset() FLOWN QUICK', me.debugPrimary, me.debugSecondary, pp ); }

            setTimeout ( ()=>{

              if ( me.debug ) { console.log ( '%c feature-detector %c ['+t.id+'] __heightOffset() GOING FLYING ** AGAIN ** ...', me.debugPrimary, me.debugSecondary, tt ); }

              me.flyThere(origin.cartographic,10000,me.slowFlyDuration,t.id).then( _ => {

                if ( me.debug ) { console.log ( '%c feature-detector %c ['+t.id+'] __heightOffset() FLOWN SLOW, DO TEST', me.debugPrimary, me.debugSecondary, tt ); }
            
                let o = me.coordHelper.positionProfile ( me.mapService.viewer.scene, 'original', gs.boundingSphere.center, { ex:ex } );

                let heights = {
                  _1_given: o.cartographic.height,
                  _2_picked: o.pickedHeight,
                  _3_sampled: o.sample,
                  _4_ground: o.groundCartesian.height,
                  _5_globePick: o.globeHeight,
                  _6_globeSampled: o.sampleEx
                };

                if ( me.debug ) { console.log ( '%c feature-detector %c ['+t.id+'] __heightOffset() *** HEIGHT_PROFILE *** ', me.debugPrimary, me.debugSecondary, tt, heights, test ); }
                resolve(test);

              });

            }, tt );

          });

        }, pp );

        

        /*
        setTimeout ( ()=>{

          let o = me.coordHelper.positionProfile ( me.mapService.viewer.scene, 'original', gs.boundingSphere.center, { ex:ex } );
          let m = me.coordHelper.positionProfile ( me.mapService.viewer.scene, 'middle', gs.boundingSphere.center, { height: 0, ex:ex } );
          let b = me.coordHelper.positionProfile ( me.mapService.viewer.scene, 'bottom', gs.boundingSphere.center, { height: -500, ex:ex } );

          let positions = [ o.radian, m.radian, b.radian ];
          let heights = [ o.cartographic.height, m.cartographic.height, b.cartographic.height ];

          if ( me.debug ) { console.log ( '%c feature-detector %c __heightOffset() SECOND', me.debugPrimary, me.debugSecondary, positions, heights, [o,m,b] ); }

        }, 4000 );

        setTimeout ( ()=>{

          let o = me.coordHelper.positionProfile ( me.mapService.viewer.scene, 'original', gs.boundingSphere.center, { ex:ex } );
          let m = me.coordHelper.positionProfile ( me.mapService.viewer.scene, 'middle', gs.boundingSphere.center, { height: 0, ex:ex } );
          let b = me.coordHelper.positionProfile ( me.mapService.viewer.scene, 'bottom', gs.boundingSphere.center, { height: -500, ex:ex } );

          let positions = [ o.radian, m.radian, b.radian ];
          let heights = [ o.cartographic.height, m.cartographic.height, b.cartographic.height ];

          if ( me.debug ) { console.log ( '%c feature-detector %c __heightOffset() RESOLVE', me.debugPrimary, me.debugSecondary, positions, heights, [o,m,b], test ); }
          resolve(test);

        }, 12000 );
        */

        /*
        const p = Cesium.sampleTerrain(this.mapService.viewer.terrainProvider, 11, positions);
        Cesium.when(p, function(updatedPositions) {
            console.log ( 'feature-detector  __heightOffset() updatedPositions', updatedPositions );
        });

        setTimeout ( ()=>{
          var promise = Cesium.sampleTerrain(this.mapService.viewer.terrainProvider, 11, positions);
          Cesium.when(promise, function(updatedPositions) {
              console.log ( 'feature-detector  __heightOffset() updatedPositions DELAYED', updatedPositions );
          });
        }, 10000 );
*/
  /*
        const entityCoordCartographic = this.worldFromCartesian( gs.boundingSphere.center );
        const entityHeight = entityCoordCartographic.height;
        let screenLocTop = Cesium.SceneTransforms.wgs84ToWindowCoordinates( this.mapService.viewer.scene, entityCoordCartographic );
        
        let groundCoordCartographic = this.worldFromCartesian( gs.boundingSphere.center );
        
        groundCoordCartographic.height = 0;
        let screenLocMiddle = Cesium.SceneTransforms.wgs84ToWindowCoordinates( this.mapService.viewer.scene, groundCoordCartographic );

        groundCoordCartographic.height = -500;
        let screenLocBottom = Cesium.SceneTransforms.wgs84ToWindowCoordinates( this.mapService.viewer.scene, groundCoordCartographic );

        const undergroundCoord = new Cesium.Cartographic.toCartesian( this.worldToRadians ( groundCoordCartographic ) );

        const ray = new Cesium.Ray( gs.boundingSphere.center, undergroundCoord );

        let pickedHeight = null;
        let pickedCartographic = null;
          let pickedHeightCart = this.mapService.viewer.scene.pickPosition (screenLocMiddle);
          if ( pickedHeightCart ) {
            pickedCartographic = new Cesium.Cartographic.fromCartesian( pickedHeightCart );
            pickedHeight = pickedCartographic.height;
          }

          let t = {
            top: screenLocTop, middle: screenLocMiddle, bottom: screenLocBottom,
            boundingHeight: entityHeight, pickedHeight
          }
        if ( this.debug ) { console.log ( '%c feature-detector %c __heightOffset() PICKING', this.debugPrimary, this.debugSecondary, t ); }


        if ( obj && obj.object ) {

          let ex = [ obj.object ];

          
          

          if ( this.debug ) { console.log ( '%c feature-detector %c __heightOffset() PICKING POS', this.debugPrimary, this.debugSecondary, entityHeight, pickedHeight, screenLoc, pickedHeightCart ); }

          const ray2 = this.mapService.viewer.camera.getPickRay(screenLocMiddle);
          var intersection = this.mapService.viewer.scene.globe.pick(ray2, this.mapService.viewer.scene);
          const intersectionCoord = new Cesium.Cartographic.fromCartesian( intersection );
        
          let sampledHeight = this.mapService.viewer.scene.sampleHeight(entityCoordCartographic,ex);
          let res = this.mapService.viewer.scene.pickFromRay(ray, ex );

          if ( this.debug ) { console.log ( '%c feature-detector %c __heightOffset() PICKING RAY', this.debugPrimary, this.debugSecondary, sampledHeight, intersectionCoord, res ); }

          // const groundCoord = new Cesium.Cartographic.toCartesian( groundCoordCartographic );
        
          ret = test;
        }

        this.mapService.viewer.entities.add({
          show: true,
          polyline: {
              positions: [ gs.boundingSphere.center, undergroundCoord ],
              width: 2.0,
              material: new Cesium.PolylineDashMaterialProperty({
                  color: Cesium.Color.WHITE,
              }),
              depthFailMaterial: new Cesium.PolylineDashMaterialProperty({
                  color: Cesium.Color.WHITE.withAlpha(0.7),
              }),
          }
      });
        */
      }

      

    });

  }

}

/* else

              if ( key == 'features' ) {

                console.log ( '@@@@@@@@ features are pushed through before anyone can even blink!', key );

                let result = me[tester]( t, item, obj );
                if ( result ) {
                  if ( isRooted ) {
                    t['__detected'][test.type] = result;
                  } else {
                    t['__detected'][test.type][key] = result;
                  }
                }

                checkedCount++;
                if ( checkedCount == this.checkList.length ) {
                  console.log ( '@@@@@@@@ kept my promise (features)', key, this.checkList.length, checkedCount, t['__detected']._meta );
                  resolve(null);
                } else {
                  console.log ( '@@@@@@@@ checked (features)', key, this.checkList.length, checkedCount, t['__detected']._meta );
                }

              } else {

                console.log ( '@@ '+key+' @@ making core promise for ['+key+']', t.id );

                this._promises[t.id][key] = new Promise ( (resolve,reject) => {

                  let coreResolve = resolve;

                  let waitFor = test.waitFor;
    
                  console.log ( '@@ '+key+' @@ inside promise', waitFor );
                  
                  if ( waitFor ) {
    
                    // first, are we waiting for an item on the map to get ready?
                    if ( waitFor == 'readyPromise' ) {
    
                      if ( t['__detected'].features && t['__detected'].features.hasReadyPromise ) {
    
                        if ( t['__detected'].features.ready ) {
                          console.log ( '@@ '+key+' @@ [readyPromise] waiting but READY' );
                          coreResolve ( me[tester]( t, item, obj ) );

                        } else {

                          let testObj = obj.object;

                          if ( t['__detected'].features.hasReadyPromiseInChild ) {
                            testObj = obj.object[t['__detected'].features.hasReadyPromiseInChild];
                          }
    
                          console.log ( '@@ '+key+' @@ [readyPromise] on Object', testObj );
                          testObj.readyPromise.then( res => {
    
                            console.log ( '@@ '+key+' @@ [readyPromise] then callBack from Object', res );
                            t['__detected'].features.ready = true;
                            coreResolve ( me[tester]( t, item, obj ) );
    
                          });
                        }
                      } else {
                        console.log ( '@@ '+key+' @@ [readyPromise] waiting ERROR' );
                      }
    
                    } else {

                      // is the thing we're waiting for already there?
                      if ( t['__detected'][waitFor] ) {
    
                        console.log ( '@@ '+key+' @@ ['+waitFor+'] waiting but was READY' );
    
                        // it's there, so ready!
                        coreResolve ( me[tester]( t, item, obj ) );
    
                      } else {
    
                        console.log ( '@@ '+key+' @@ ['+waitFor+'] waiting on' );
    
                        // not there, so not ready yet
                        this._promises[t.id][waitFor].then( result => {
    
                          console.log ( '@@ '+key+' @@ ['+waitFor+'] returning wait for', result );
    
                          coreResolve ( me[tester]( t, item, obj ) );
    
                        });
    
                      }
    
                    }
    
                  } else {
                    console.log ( '@@ '+key+' @@ NOT waiting' );
                    coreResolve ( me[tester]( t, item, obj ) );
                  }

                }).then( result => {
    
                  console.log ( '@@ '+key+' @@ THEN finally RESOLVE' );
    
                  if ( result ) {
                    if ( isRooted ) {
                      t['__detected'][test.type] = result;
                    } else {
                      t['__detected'][test.type][key] = result;
                    }
                  }

                  checkedCount++;
                  if ( checkedCount == this.checkList.length ) {
                    console.log ( '@@@@@@@@ kept my promise (inside promises)', key, this.checkList.length, checkedCount, t['__detected']._meta );
                    resolve(null);
                  } else {
                    console.log ( '@@@@@@@@ checked (inside promises)', key, this.checkList.length, checkedCount, t['__detected']._meta );
                  }
    
                });

              } */